const removeAccents = (str) => {
  return str
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

// O termo vem digitado pelo usuário: pontuação de CPF e de telefone é metacaractere de regex, e
// um "(" solto lança SyntaxError se entrar cru no padrão.
const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const normalizedContains = (item, stringSearch) => {
  const regExp = new RegExp(escapeRegExp(removeAccents(stringSearch)), "gi");
  return regExp.test(removeAccents(item));
};

const findMatching = (stringSearch, collection) => {
  return collection.filter((item) => normalizedContains(item, stringSearch));
};

export { findMatching, normalizedContains };
